import { useEffect, useCallback, RefObject } from 'react';

const useArrowKeys = (
  ref: RefObject<HTMLElement | null>,
  callback: (e: any) => void
) => {
  const keySet = new Set(['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft']);
  const handleKeypress = useCallback(
    e => {
      if (ref.current && keySet.has(e.key)) {
        callback(e);
      }
    },
    [ref, callback, keySet]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeypress);

    return () => {
      document.removeEventListener('keydown', handleKeypress);
    };
  }, [handleKeypress]);
};

export default useArrowKeys;
